var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 2",
    fill: "#0093b9",
    height: 6,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0.0 0.0 37.7 6.0",
    width: 37.7,
    zoomAndPan: "magnify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "change1_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.133 1.977L3.157 0 2.182 1.977 0 2.294 1.579 3.833 1.206 6.005 3.157 4.98 5.109 6.005 4.736 3.833 6.314 2.294 4.133 1.977z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.97 1.977L10.995 0 10.019 1.977 7.837 2.294 9.416 3.833 9.043 6.005 10.995 4.98 12.946 6.005 12.573 3.833 14.152 2.294 11.97 1.977z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.807 1.977L18.832 0 17.856 1.977 15.675 2.294 17.253 3.833 16.88 6.005 18.832 4.98 20.783 6.005 20.41 3.833 21.989 2.294 19.807 1.977z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.645 1.977L26.669 0 25.693 1.977 23.512 2.294 25.09 3.833 24.718 6.005 26.669 4.98 28.62 6.005 28.248 3.833 29.826 2.294 27.645 1.977z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.664 2.294L35.482 1.977 34.506 0 33.531 1.977 31.349 2.294 32.928 3.833 32.555 6.005 34.506 4.98 36.458 6.005 36.085 3.833 37.664 2.294z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.64d9d9d2527ed6324b189f7468313981.svg";
export { ForwardRef as ReactComponent };